module.exports = __webpack_public_path__ + "img/ArgCroacia6.c61a21e8.jpg";